<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="emEquipmentcheckrecord.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="emEquipmentcheckrecord"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="设备编号" prop="equipmentNO">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="emEquipmentcheckrecord.equipmentNO" placeholder="请输入" readonly>
              <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectEquipmentNO.open()">选择设备</el-button>
            </el-input>
            <equipment-select ref="selectEquipmentNO" @select="selectEquipmentNO"/>
          </div>
        </el-form-item>
        <el-form-item label="点检月份">
          <el-input v-model="emEquipmentcheckrecord.checkMonth" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="检查内容">
          <el-input v-model="emEquipmentcheckrecord.checkContent" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="检查方法">
          <el-input v-model="emEquipmentcheckrecord.checkWay" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="检查类型">
          <el-select v-model="emEquipmentcheckrecord.checkType" style="width: 220px" clearable placeholder="请选择">
            <el-option
                v-for="item in checkTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
          <el-input v-model="emEquipmentcheckrecord.checkType" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="检查结果">
          <el-select v-model="emEquipmentcheckrecord.checkResult" style="width: 220px" clearable placeholder="请选择">
            <el-option
                v-for="item in checkResults"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
          <el-input v-model="emEquipmentcheckrecord.checkType" placeholder="请输入"/>
        </el-form-item>
        <!--        <el-form-item label="检查人">-->
        <!--          <el-input v-model="emEquipmentcheckrecord.checkUserName" placeholder="请输入"/>-->
        <!--        </el-form-item>-->
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  import EquipmentSelect from "@/views/em/Equipment/EquipmentSelect";
  import constant from "@/util/constant";
  export default {
    name:"EMEquipmentcheckrecordEdit",
    components: {EquipmentSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        checkTypes: constant.toSelect(constant.checkTypes),
        checkResults: constant.toSelect(constant.checkResults),
        emEquipmentcheckrecord: {
          pkid: 0,
          equipmentID: "",
          equipmentNO: "",
          checkMonth: "",
          checkContent: "",
          checkWay: "",
          checkType: "",
          checkResult: "",
        },
        ruleValidate: {
          equipmentNO: {required: true, message: "设备编号不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.emEquipmentcheckrecord.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `emEquipmentcheckrecords/${this.emEquipmentcheckrecord.pkid}`)
          .then(resp => {
            console.log(resp);
            this.emEquipmentcheckrecord = resp;
          });
      },
      selectEquipmentNO(row) {
        this.emEquipmentcheckrecord.equipmentID = row.pkid;
        this.emEquipmentcheckrecord.equipmentNO = row.no;
      },
      handleSubmit() {
        if(this.emEquipmentcheckrecord.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "emEquipmentcheckrecords",  this.emEquipmentcheckrecord)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "emEquipmentcheckrecords", this.emEquipmentcheckrecord)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
